import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './WorkersWelfare.css';

const WorkersWelfare = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['कामगार कल्याण निधी', 'अधिनियम', 'योगदान', 'नोंदणी फॉर्म', 'वर्गणी'],
    en: ['labours welfare fund', 'labours\' welfare fund', 'workers welfare fund', 'act', 'contribution', 'registration form', 'contribution']
  });

  const pageHeaderData = {
    title: {
      marathi: 'कामगार कल्याण निधी',
      english: 'Labours\' Welfare Fund'
    },
    subtitle: {
      marathi: 'कामगार कल्याण निधीची माहिती आणि अधिनियम',
      english: 'Information and Act of Labours\' Welfare Fund'
    }
  };

  return (
    <div className="workers-welfare">
      <div className="workers-welfare-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        {/* Main Content */}
        <div className="welfare-content" data-read-section="workers-welfare-content">
          {/* Fund Overview */}
          <section className="welfare-section">
            <h2 className="section-title">
              {isMarathi() ? 'अधिनियम' : 'Act'}
            </h2>
            <div className="section-content">
              <div className="section-text">
                {isMarathi() ? (
                  <div>
                    <p style={{textAlign: 'center'}}><strong>महाराष्ट्र कामगार कल्याण निधी अधिनियम १९५३</strong></p>
                    
                    <p>महाराष्ट्र कामगार कल्याण निधी अधिनियमाच्या कलम - ३ नुसार विविध कल्याणकारी कार्यक्रमांच्या अंमलबजावणीसाठी हा कामगार कल्याण निधी स्थापन करण्यात आला आहे. अधिनियमाच्या कलम-३ नुसार आर्थिक सहाय्य मंडळाला मिळते.</p>
                    
                    <p>१) कामगार कर्मचा-यांकडून वसूल करण्यात आलेल्या सर्व दंडाच्या रकमा.</p>
                    
                    <p>२) कलम ६ -अ (९) नुसार अवितरित संचयनाच्या रकमा.</p>
                    
                    <p>३) सन १९७१ मधील बदलांन्वये अधिनियमाच्या कलम ६ बब नुसार कामगार, मालक व शासन अशी द्विपक्षीय वर्गणी ६ महिन्यातून एकदा मंडळाला मिळते. सदर वर्गणी माहे जून व माहे डिसेंबरच्या वेतनातून कपात करण्यात येते. "कारखाने अधिनियम १९४८" अंतर्गत येणारे सर्व कारखाने तसेच "बॉंम्बे शॉप्स अँन्ड एस्टब्लिशमेंट अॅक्ट १९४८" अंतर्गत येणारी सर्व दुकाने व आस्थापना (ज्यामध्ये ५ किंवा जास्त कामगार काम करीत आहेत) "मोटार वाहतूक कामगार कायद्यांतर्गत येणारे कामगार या सर्वाकडून मंडळाला खालीलप्रमाणे अंशदान मिळते,</p>
                    
                    <p>योगदानाचे जुने दर खालील प्रमाणे:</p>
                    
                    <div className="contribution-table">
                      <table>
                        <thead>
                          <tr>
                            <th>तपशील</th>
                            <th>कामगार (रूपये)</th>
                            <th>मालक (रूपये)</th>
                            <th>शासन (रूपये)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>अ) दरमहा रु. ३०००/- पर्यंत पगार घेत असलेले कामगार</td>
                            <td>६.००</td>
                            <td>१८.००</td>
                            <td>१२.००</td>
                          </tr>
                          <tr>
                            <td>ब) दरमहा रू. ३०००/- हून अधिक पगार घेत असलेले कामगार</td>
                            <td>१२.००</td>
                            <td>३६.००</td>
                            <td>२४.००</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                    <p>कायद्याच्या कलम 6BB मध्ये सुधारणा केल्यानंतर, योगदानाचा सुधारित दर जून 2024 पासून लागू:</p>
                    
                    <div className="contribution-table">
                      <table>
                        <thead>
                          <tr>
                            <th colSpan="3">सहामाही अंशदान दर</th>
                          </tr>
                          <tr>
                            <th>कामगारांचे अंशदान प्रती कामगार</th>
                            <th>मालकांचे अंशदान प्रती कामगार</th>
                            <th>शासन अंशदान प्रती कामगार</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>रु.२५/-</td>
                            <td>रु.७५/-</td>
                            <td>रु.५०/-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                    <p>४) कलम ६- (ब) नुसार दंडार्थ मिळणारी व्याजाची रक्कम</p>
                    
                    <p>५) मंडळास मिळणा-या कोणत्याही ऐच्छिक देणग्या</p>
                    
                    <p>६) कलम (५) नुसार वळती केलेली कोणतीही निधीची रक्कम</p>
                    
                    <p>७) कलम ८ नुसार कर्जाऊ घेतलेली रक्कम</p>
                    
                    <p>८) शासनाकडून कर्ज किंवा मदत म्हणून मिळालेली रक्कम</p>
                    
                    <p>मंडळ या निधी चे विश्वस्त असून, कामगार कल्याण कायद्याच्या कलम ७(२) अन्वये या निधीचा विनियोग करण्यासंबंधी कामगार कल्याण कार्याची चौकट ठरवून देण्यात आलेली आहे.</p>
                    
                    <p>सदरनिधीचा खालील प्रमाणेविनियोगकेलाजातो:</p>
                    
                    <p>१) वाचनालये व ग्रंथालये यांचा समावेश असणारी सामुदायिक आणि सामाजिक शिक्षण केंद्राची सोय.</p>
                    
                    <p>२) शिशु मंदिरे, शिशु संगोपनालये, अभ्यासिका इत्यादीद्वारे सामुदायिक गरजांकरिता तरतुद</p>
                    
                    <p>३) खेळ व खेळस्पर्धा (शरीरसंवर्धन इ.)</p>
                    
                    <p>४) सहली, सफरी</p>
                    
                    <p>५) मनोरंजनात्मक व इतर करमणुकीचे कार्यक्रम</p>
                    
                    <p>६) कामगार वर्गातील स्त्रियांसाठी व बेरोजगारांसाठी स्वयंरोजगार शिबिर व व्यवसाय प्रशिक्षण केंद्र</p>
                    
                    <p>७) सामाजिक स्वरूपाचे सामुदायिक कार्यक्रम.</p>
                    
                    <p>८) कामगारांची सामाजिक स्थिती सुधारण्यासाठी तसेच त्यांच्या राहणीमानाचा दर्जा उंचावण्यासाठी शासनाच्या दृष्टीने उपयुक्त असे कार्यक्रम.</p>
                    
                    <p>महाराष्ट्र राज्यात २२६ कामगार कल्याण केंद्रे कार्यान्वित आहेत. तसेच मुंबई, नागपूर आणि पुणे येथे प्रत्येकी एक असे तीन सुसज्ज असे प्रकल्प आहेत. साधारणपणे त्या-त्या ठिकाणच्या जागेची उपलब्धता, सोयी व सुविधा यावरून कामगार कल्याण केंद्राची वर्गवारी ठरविण्यात येते. यावर्गवारी नुसार कामगार कल्याण केंद्राची कामगार क्रीडा भवन, कामगार कल्याण भवन, ललित कला भवन, कामगार कल्याण केंद्र व उपकेन्द्र अशा प्रकारात विभागणी करण्यात आली आहे. याशिवाय ग्रामीण केंद्रे, सहकारी साखर कारखान्यांच्या परिसरातील समिती पद्धत्तीवर सुरू करण्यात आलेली केंद्रे, आदिवासी विभागातील केंद्रे, असे केंद्रांचे काही प्रकारही अस्तित्वात आहेत. या शिवाय ज्या कामगार विभागात नियमित स्वरूपाची केंद्रे नाहीत अशा कामगार वसाहतीमधून 'कामगार वसाहत्तीतील कल्याण कार्य' या सदराखाली काही प्रासंगिक स्वरूपाच्या कार्यंक्रमांचे आयोजन केले जाते.</p>
                  </div>
                ) : (
                  <div>
                    <p style={{textAlign: 'center'}}><strong>Maharashtra Labour Welfare Fund Act 1953</strong></p>
                    
                    <p>This Labour Welfare Fund has been established under Section 3 of the Maharashtra Labour Welfare Fund Act for the implementation of various welfare programs. The board receives financial assistance under Section 3 of the Act.</p>
                    
                    <p>1) All amounts of fines collected from workers and employees.</p>
                    
                    <p>2) Amounts of undistributed accumulation under Section 6-A (9).</p>
                    
                    <p>3) As per the amendments of 1971, under Section 6-BB of the Act, the board receives bilateral contribution from workers, employers and government once every 6 months. This contribution is deducted from the salary of June and December months. The board receives contribution from all factories under "Factories Act 1948" and all shops and establishments under "Bombay Shops and Establishments Act 1948" (where 5 or more workers are employed) and workers under "Motor Transport Workers Act" as follows:</p>
                    
                    <p>Old contribution rates are as follows:</p>
                    
                    <div className="contribution-table">
                      <table>
                        <thead>
                          <tr>
                            <th>Details</th>
                            <th>Worker (Rupees)</th>
                            <th>Owner (Rupees)</th>
                            <th>Government (Rupees)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>a) Workers earning up to Rs. 3000/- per month</td>
                            <td>6.00</td>
                            <td>18.00</td>
                            <td>12.00</td>
                          </tr>
                          <tr>
                            <td>b) Workers earning more than Rs. 3000/- per month</td>
                            <td>12.00</td>
                            <td>36.00</td>
                            <td>24.00</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                    <p>After the amendment in Section 6BB of the Act, the revised contribution rate is applicable from June 2024:</p>
                    
                    <div className="contribution-table">
                      <table>
                        <thead>
                          <tr>
                            <th colSpan="3">Half-yearly Contribution Rate</th>
                          </tr>
                          <tr>
                            <th>Employee's Contribution per Worker</th>
                            <th>Employer's Contribution per Worker</th>
                            <th>Government's Contribution per Worker</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Rs. 25/-</td>
                            <td>Rs. 75/-</td>
                            <td>Rs. 50/-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                    <p>4) Interest amount received as penalty under Section 6-(b)</p>
                    
                    <p>5) Any voluntary donations received by the board</p>
                    
                    <p>6) Any amount of fund transferred under Section (5)</p>
                    
                    <p>7) Amount borrowed under Section 8</p>
                    
                    <p>8) Amount received as loan or assistance from the government</p>
                    
                    <p>The board is the trustee of this fund, and under Section 7(2) of the Labour Welfare Act, a framework for labour welfare work has been established regarding the utilization of this fund.</p>
                    
                    <p>The said fund is utilized in the following manner:</p>
                    
                    <p>1) Community and social education centers including libraries and reading rooms.</p>
                    
                    <p>2) Provisions for community needs through children's temples, children's care centers, study rooms, etc.</p>
                    
                    <p>3) Sports and competitions (physical development, etc.)</p>
                    
                    <p>4) Trips and tours</p>
                    
                    <p>5) Entertainment and other recreational programs</p>
                    
                    <p>6) Self-employment camps and vocational training centers for women in the working class and unemployed</p>
                    
                    <p>7) Social community programs.</p>
                    
                    <p>8) Programs useful from the government's perspective to improve the social status of workers and raise their standard of living.</p>
                    
                    <p>226 labour welfare centers are operational in Maharashtra state. Also, there are three well-equipped projects in Mumbai, Nagpur, and Pune. Generally, the classification of labour welfare centers is determined based on the availability of space, facilities, and amenities at their respective locations. According to this classification, labour welfare centers are divided into categories such as labour sports building, labour welfare building, fine arts building, labour welfare center, and sub-center. Apart from this, there are also some types of centers in rural areas, centers started on committee basis in the premises of cooperative sugar factories, centers in tribal areas. Apart from this, in labour settlements where there are no regular centers, some occasional programs are organized under the heading 'Welfare work in labour settlements'.</p>
                  </div>
                )}
              </div>
            </div>
          </section>


          {/* Registration Form Section */}
          <section className="welfare-section">
            <h2 className="section-title">
              {isMarathi() ? 'नोंदणी फॉर्म' : 'Registration Form'}
            </h2>
            <div className="section-content">
              <div className="quick-links-list">
                <a 
                  href="/documents/workers-welfare/asthapana_nondani_form.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="quick-link-item"
                >
                  <svg className="quick-link-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14,2 14,8 20,8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                    <polyline points="10,9 9,9 8,9"/>
                  </svg>
                  <span className="quick-link-text">
                    {isMarathi() ? 'अ) आस्थापना नोंदणी फॉर्म' : 'A) Establishment Registration Form'}
                  </span>
                </a>
                
                <a 
                  href="/documents/workers-welfare/form_A1_nidhi_bharana_form.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="quick-link-item"
                >
                  <svg className="quick-link-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14,2 14,8 20,8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                    <polyline points="10,9 9,9 8,9"/>
                  </svg>
                  <span className="quick-link-text">
                    {isMarathi() ? 'ब) महाराष्ट्र कामगार कल्याण निधी भरण्यासाठी फॉर्म - ए-१' : 'B) Maharashtra Labour Welfare Fund Payment Form - A-1'}
                  </span>
                </a>
                
                <a 
                  href="/documents/workers-welfare/form_C_avitarit_sanchayanasathi.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="quick-link-item"
                >
                  <svg className="quick-link-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14,2 14,8 20,8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                    <polyline points="10,9 9,9 8,9"/>
                  </svg>
                  <span className="quick-link-text">
                    {isMarathi() ? 'क) अवितरित संचयनासाठी फॉर्म - सी' : 'C) Undistributed Accumulation Form - C'}
                  </span>
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default WorkersWelfare;
